import { useState } from "react";
import { createId } from "src/utils/strings";

// useId from react doesn't return valid html ids. wtf, indeed.
export function useUniqueId() {
  return useState(createId())[0];
}
